var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBolt = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20124 11.188L7.14615 11.3029C6.6581 12.4202 7.44988 13.7133 8.66821 13.7133L10.3318 13.7069L7.85117 21.9631C7.49932 23.8858 10.051 24.8155 10.9544 23.0938L16.7978 11.9569L16.8531 11.842C17.3427 10.7246 16.551 9.42988 15.3318 9.42988L13.6636 9.42347L15.3011 2.02692C15.6413 0.106696 13.0945 -0.810919 12.1952 0.907863L7.20124 11.188Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBolt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconBolt.32cff43047973a96972ede2b84c4cda3.svg";